import { render } from "./Dashboard.vue?vue&type=template&id=e510e734&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=e510e734&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e510e734"

export default script